import MuiMenuItem from '@mui/material/MenuItem';
import {styled} from '@mui/material/styles';
import {forwardRef} from 'react';

import type {MenuItemProps as MuiMenuItemProps} from '@mui/material/MenuItem';

export type OptionProps = MuiMenuItemProps;

const StyledOption = styled(MuiMenuItem)<MuiMenuItemProps>(({
    theme, hidden
}) => ({
    padding: `0.25rem ${theme.tokens.FuelSpacing2}`,
    ...hidden && {
        display: 'none'
    }
}));

export const Option = forwardRef<HTMLLIElement, MuiMenuItemProps>(({
    children, ...props
}, ref) => (
    <StyledOption
        {...props}
        ref={ref}
    >
        {children}
    </StyledOption>
));

Option.displayName = 'Option';
